export const privacy = {
  "header": {
    "badge": "Dane osobowe",
    "title": "Polityka prywatności"
  },
  "content": {
    "intro": "Ochrona Twojej prywatności i danych osobowych jest dla DONKEY TRAVEL absolutnym priorytetem. Niniejsza polityka szczegółowo opisuje, w jaki sposób zbieramy, przetwarzamy i zabezpieczamy Twoje dane.",
    "collection": {
      "title": "1. Gromadzenie danych",
      "text": "Gromadzimy wyłącznie dane absolutnie niezbędne do prawidłowego funkcjonowania platformy: informacje o utworzeniu konta (nazwisko, imię, adres e-mail), linki do Twoich ogłoszeń publicznych (Airbnb) oraz Twoje preferencje dotyczące podróży i dostępność. Hasła są szyfrowane, a dane dotyczące płatności przetwarzane są przez naszego bezpiecznego partnera Stripe."
    },
    "usage": {
      "title": "2. Wykorzystanie Twoich danych",
      "text": "Twoje dane są wykorzystywane do: \n- Sprawdź, czy się kwalifikujesz (ocena 4,5+) \n- Zarządzaj swoją subskrypcją \n- Ułatwienie połączenia z innymi członkami \n- Zapewniaj spersonalizowane rekomendacje za pośrednictwem naszego inteligentnego dopasowywania \n- Udoskonalać nasze usługi i rozwiązywać problemy techniczne."
    },
    "sharing": {
      "title": "3. Dzielenie się informacjami",
      "text": "NIGDY nie będziemy sprzedawać Twoich danych osobowych osobom trzecim. Udostępnianie ich jest ściśle ograniczone do celów operacyjnych naszym zaufanym dostawcom usług (hosting, narzędzie płatnicze). Poza tymi ramami Twoje dane są udostępniane pomiędzy członkami jedynie w celu organizacji wymiany (i tylko dokładny adres po zatwierdzeniu wymiany)."
    },
    "security": {
      "title": "4. Bezpieczeństwo",
      "text": "Stosowane są najsolidniejsze protokoły uwierzytelniania i bezpieczeństwa, które chronią Twoje dane przed nieautoryzowanym dostępem, zmianą, ujawnieniem lub zniszczeniem."
    },
    "rights": {
      "title": "5. Twoje prawa (RODO)",
      "text": "Zgodnie z Ogólnym rozporządzeniem o ochronie danych, w każdej chwili masz prawo dostępu do swoich danych osobowych, ich poprawiania, przenoszenia lub usunięcia. Możesz skorzystać z tego prawa w ustawieniach swojego konta lub pisząc do nas na adres dpo@donkey.travel."
    },
    "cookies": {
      "title": "6. Pliki cookie",
      "text": "Używamy niezbędnych plików cookie, aby utrzymać Twoją sesję logowania, a także anonimowych analitycznych plików cookie, aby zrozumieć, w jaki sposób używana jest nasza witryna i poprawić Twoje doświadczenia."
    }
  }
};
